import React, { useEffect } from "react";
import { Button, Col, Form, Radio, Row } from "antd";
import { userService } from "../../services/user.service";
import { useSelector } from "react-redux";

export const FormUserFlag = ({ handleNextStatus, genderIdentityCatalog, handleUpdateProfile, profileInfo }) => {
  const [form] = Form.useForm();
  const companyId = useSelector((state) => state.userSettings.companyId);

  useEffect(() => {
    form.setFieldsValue({ GenderIdentityId: profileInfo?.genderIdentityId });
  }, [profileInfo.genderIdentityId, form]);

  const onSubmit = async (values) => {
    try {
      const response = await userService.editProfile(values, companyId);
      if (response?.success) {
        handleUpdateProfile();
        handleNextStatus("default", 4);
        return localStorage.removeItem("stepContentComplete");
      }
    } catch (error) {
      console.error("Error en el registro:", error);
    }
  };

  const selected = Form.useWatch("GenderIdentityId", form);

  return (
    <article className="profile__form">
      <Form
        form={form}
        onFinish={onSubmit}
        layout="vertical"
        className="form-light"
        initialValues={{ genderIdentityId: profileInfo?.genderIdentityId }}
      >
        <Row gutter={[0, 8]}>
          <Col xs={24}>
            <div className="form-light__title">
              <h4>Configura tu perfil</h4>
              <p>Tu bandera</p>
              <small>Elige la bandera con la que te identificas</small>
            </div>
          </Col>

          <Col xs={24}>
            <Form.Item
              name="GenderIdentityId"
              rules={[{ required: true, message: "*Campo requerido" }]}
            >
              <Radio.Group rootClassName="ant-radio-flag">
                {genderIdentityCatalog?.map((gender) => (
                  <Radio
                    key={gender.genderIdentityId}
                    value={gender.genderIdentityId}
                    className={gender.genderIdentityId}
                  >
                    <div
                      className={`flag ${gender.identityFlagName} ${
                        selected === gender.genderIdentityId ? "checked" : ""
                      }`}
                    />
                    <p>{gender.genderName}</p>
                  </Radio>
                ))}
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>

        <div className="form-light__footer">
          <Button
            htmlType="button"
            type="default"
            block
            onClick={() => handleNextStatus("default", 3)}
          >
            Regresar
          </Button>
          <Button htmlType="submit" type="primary" block>
            Guardar
          </Button>
        </div>
      </Form>
    </article>
  );
};
